.wrap {
  display: inline-block;
  font-size: 15px;
  margin-right: 10px;
  pointer-events: none;
  user-select: none;
}

.warning {
  color: red;
}